import React from "react";
import styled from "styled-components";
import { H2 } from "./Styles";

function OurValues() {
  const values = [
    {
      title: "Respect",
      color: "#00838c",
      description: [
        "Value every individual we interact with",
        "Embrace diverse knowledge and skills",
        "Listen actively and seek perspectives",
      ],
    },
    {
      title: "Integrity",
      color: "#00838c",
      description: [
        "Always do the right thing",
        "Be truthful in everything",
        "Stand by your beliefs",
      ],
    },
    {
      title: "Problem Solving",
      color: "#00838c",
      description: [
        "Innovate to deliver value",
        "Create smart, sustainable solutions",
        "Challenge the status quo",
        "Turn change into opportunity",
      ],
    },
    {
      title: "Trust",
      color: "#00838c",
      description: [
        "Foster transparency and collaboration",
        "Empower through delegation",
      ],
    },
    {
      title: "Rigour & Quality",
      color: "#00838c",
      description: [
        "Make data-driven decisions",
        "Think deeply, analyze rigorously",
        "Perfect the details",
        "Stay focused on goals",
      ],
    },
  ];

  return (
    <Container>
      <Header>
        <H2 style={{ textAlign: "center" }}>Our Values</H2>
      </Header>

      <ValuesGrid>
        {values.map((value, index) => (
          <ValueCard key={index} accentColor={value.color}>
            <ValueTitle>{value.title}</ValueTitle>
            <Divider accentColor={value.color} />
            <ValueDescription>
              {value.description.map((item, i) => (
                <ListItem key={i}>
                  <CheckMark accentColor={value.color}>✓</CheckMark>
                  <ItemText>{item}</ItemText>
                </ListItem>
              ))}
            </ValueDescription>
          </ValueCard>
        ))}
      </ValuesGrid>
    </Container>
  );
}

export default OurValues;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }

  @media (max-width: 480px) {
    padding: 2rem 1rem;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 5rem;

  @media (max-width: 768px) {
    margin-bottom: 3rem;
  }
`;

// const ValuesGrid = styled.div`
//   display: grid;
//   gap: 4rem;
//   justify-content: center;

//   @media (min-width: 769px) {
//     grid-template-columns: repeat(6, 1fr);
//     max-width: 1300px;
//     margin: 0 auto;
//     gap: 5rem;

//     & > :nth-child(1) {
//       grid-column: 1 / span 2;
//     }
//     & > :nth-child(2) {
//       grid-column: 3 / span 2;
//     }
//     & > :nth-child(3) {
//       grid-column: 5 / span 2;
//     }

//     & > :nth-child(4) {
//       grid-column: 2 / span 2;
//     }
//     & > :nth-child(5) {
//       grid-column: 4 / span 2;
//     }
//   }

//   @media (max-width: 1024px) and (min-width: 769px) {
//     grid-template-columns: repeat(3, 1fr);
//     gap: 3rem;
//     & > * {
//       grid-column: span 1;
//     }
//   }

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 2.5rem;
//   }
// `;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr; /* mobile default */
  gap: 2rem; /* mobile-friendly gap */
  justify-content: center;
  padding: 0 1rem; /* prevent horizontal scroll */

  /* Tablet / small screens */
  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem;
  }

  /* Desktop */
  @media (min-width: 1025px) {
    grid-template-columns: repeat(6, 1fr);
    max-width: 1300px;
    margin: 0 auto;
    gap: 5rem;

    & > :nth-child(1) {
      grid-column: 1 / span 2;
    }
    & > :nth-child(2) {
      grid-column: 3 / span 2;
    }
    & > :nth-child(3) {
      grid-column: 5 / span 2;
    }
    & > :nth-child(4) {
      grid-column: 2 / span 2;
    }
    & > :nth-child(5) {
      grid-column: 4 / span 2;
    }
  }
`;

const ValueCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 2.5rem 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 2px solid #f0f0f0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  text-align: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: ${(props) => props.accentColor || "#00838c"};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.4s ease;
  }

  &:hover {
    transform: translateY(-12px);
    box-shadow: 0 16px 50px rgba(0, 0, 0, 0.15);
    border-color: ${(props) => props.accentColor || "#00838c"};
    background-color: ${(props) => props.accentColor || "#00838c"};

    &::before {
      transform: scaleX(1);
    }
  }

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const ValueTitle = styled.h3`
  font-size: 1.7rem;
  font-family: openSans-SemiBold, sans-serif;
  color: #293461;
  margin: 0.5rem 0 1rem;
  transition: color 0.3s ease;

  ${ValueCard}:hover & {
    color: #ffffff;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: ${(props) => props.accentColor || "#00838c"};
  margin: 0 auto 1.8rem;
  border-radius: 2px;
  transition: all 0.4s ease;

  ${ValueCard}:hover & {
    width: 100px;
    background: #ffffff;
  }
`;

const ValueDescription = styled.div`
  text-align: left;
  margin-top: 0.5rem;
`;

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  transition: all 0.3s ease;

  &:last-child {
    margin-bottom: 0;
  }

  ${ValueCard}:hover & {
    transform: translateX(8px);
  }
`;

const CheckMark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: ${(props) => `${props.accentColor || "#00838c"}20`};
  color: ${(props) => props.accentColor || "#00838c"};
  border-radius: 50%;
  font-size: 0.9rem;
  font-weight: bold;
  margin-right: 1rem;
  flex-shrink: 0;
  transition: all 0.3s ease;

  ${ValueCard}:hover & {
    background: rgba(255, 255, 255, 0.3);
    color: #ffffff;
  }
`;

const ItemText = styled.span`
  font-size: 1rem;
  color: #293461;
  line-height: 1.7;
  font-family: openSans-Regular, sans-serif;

  ${ValueCard}:hover & {
    color: #ffffff;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;
